import { useCallback, useEffect, useState } from "react";
import { Cookies } from "react-cookie";

const cookies = new Cookies();
const CookieConsent = () => {
    const [showConsent, setShowConsent] = useState(null);

    const handleConsent = useCallback((consentType) => {
        setShowConsent(false);
        sendPermission(consentType);
        cookies.set("cookieAllowed", consentType ? "allowed" : "not-allowed");
    }, [])

    const sendPermission = useCallback((permission) => {
        if (window.clarity) {
            window.clarity('consentv2', {
                ad_Storage: permission ? "granted" : "denied",
                analytics_Storage: permission ? "granted" : "denied"
            });
        }
    }, [])

    useEffect(() => {
        const isAllowed = cookies.get("cookieAllowed");
        if (isAllowed != null) {
            setShowConsent(false);
            sendPermission(isAllowed == "allowed");
        } else setShowConsent(true);
    }, [])
    
    return showConsent ? <div className="position-fixed start-50 bottom-0 translate-middle-x px-2 pb-1 cookie-alert" style={{ zIndex: 100 }}>
        <div className="cookie-wrap d-flex align-items-center bg-dark rounded-2 p-2">
            <div className="cookie-text d-flex align-items-start gap-1">
                <i className="fa-regular fa-cookie-bite me-1 text-white" />
                <p className="mb-0 text-white" style={{ fontSize: "12px" }}>
                    This app uses cookies for functionality, analytics and personalization. See our
                    <a className="ms-1 btn-link text-danger" href={`https://socialwalls.com/privacy-policy`} target="_blank">Privacy Policy</a>
                </p>
            </div>
            <div className="d-flex align-items-center gap-2 cookie-btns">
                <button className="btn btn-sm btn-light py-2 px-3 py-sm-1 px-sm-2" style={{ fontSize: "10px" }} onClick={() => handleConsent(false)}>Reject</button>
                <button className="btn btn-sm btn-primary py-2 px-3 p-1 py-sm-1 px-sm-2" style={{ fontSize: "10px" }} onClick={() => handleConsent(true)}>Accept</button>
            </div>
        </div>
    </div> : null
}

export default CookieConsent;